// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__4N+9Z","loading-icon":"loading_loading-icon__wUjIw","loading-text":"loading_loading-text__1hEre","spin":"loading_spin__gY15v"};